import {FeatureConfig} from '@/shared/constants/featuresFlag'

export const BASE_URL_PLACEHOLDER = {
  ADMIN_PORTAL: `{{${FeatureConfig.apiAdminUrl}}}`,
  EVENTS: `{{${FeatureConfig.apiEventsUrl}}}`,
}

/**
 * @deprecated Use the new API endpoints defined in the API_CONFIG object.
 */
export const ENDPOINTS = {

  // MARK: - Admin-Portal Endpoints
  LOAD_USER_ROLES: `${BASE_URL_PLACEHOLDER.ADMIN_PORTAL}/v1/users/auth/cct`,

  // MARK: - Real-Time Events Endpoints
  LOAD_EVENTS: `${BASE_URL_PLACEHOLDER.EVENTS}/eventnotifications`,
  CREATE_EVENT: `${BASE_URL_PLACEHOLDER.EVENTS}/eventnotifications`,
  LOAD_EVENT: `${BASE_URL_PLACEHOLDER.EVENTS}/eventnotifications/:id`,

  // master tables
  LOAD_COUNTRIES: '/countries',
  LOAD_LANGUAGES: '/languages',
}
